import { Device } from "./device";
import { observable } from "aurelia-framework";
import { Property } from "./property";

export class Structure {
    id: string;
	code: string;
	name: string;
	devices: Array<Device>;
	deviceTypeIds: Array<string>;
	properties: Array<Property>;
	notificationStatus: number;
	statusColor: string = null;
	hasCurtainControllers: boolean;
}